import React from 'react';
import './styles.css';

import { useNavigate, useLocation, Link } from 'react-router-dom';

const ButtonLink = ({ text, link, hovered }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAnchorClick = (e) => {
    if (link.startsWith('#')) {
      e.preventDefault();
      const target = link.slice(1);

      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const targetElement = document.getElementById(target);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      } else {
        const targetElement = document.getElementById(target);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  };

  if (link.startsWith('#')) {
    return (
      <a href={link} onClick={handleAnchorClick}>
        <p className="button-link w-max">{text}</p>
      </a>
    );
  }

  return (
    <Link to={link}>
      <p className={`${hovered ? 'hover' : ''} button-link w-max`}>{text}</p>
    </Link>
  );
};

export default ButtonLink;
